import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import type { MaxLessonsPerDay } from 'shared/api';

interface UseMaxLessonsPerDayViewProps {
  maxLessonsPerDay: MaxLessonsPerDay;
}

export const useMaxLessonsPerDayView = ({ maxLessonsPerDay }: UseMaxLessonsPerDayViewProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = useAppForm<MaxLessonsPerDay>();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(maxLessonsPerDay);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
    },
  };
};
